import endpoints from '../../config/endpoints.json'
import axios from 'axios'
import { IFeedback } from '../../domain/entities/Feedback'

export function sendFeedback(feedback: IFeedback): Promise<void> {
  return axios.post(endpoints.feedback.post, feedback)
}
